import { NgOptimizedImage } from '@angular/common'
import { Component, input, output } from '@angular/core'

import type { ArticleCategory } from '../../../../../api/responses'
import type { ArticleWithNullableRefs } from '../../../../../types/types'

@Component({
  standalone: true,
  selector: 'dhp-article-category-button',
  templateUrl: './article-category-button.html',
  imports: [NgOptimizedImage],
})
export class ArticleCategoryButton {
  public readonly article = input.required<ArticleWithNullableRefs>()
  public readonly category = input.required<ArticleCategory>()

  protected readonly categoryArticle = output<{
    article: ArticleWithNullableRefs
    category: ArticleCategory
  }>()

  isClickable(): boolean {
    return !!(
      this.article().magazine?.manual_url && this.category().manual_page_number
    )
  }

  onClick(event: Event): void {
    event.stopPropagation()

    this.categoryArticle.emit({
      article: this.article(),
      category: this.category(),
    })
  }
}
